<div class="container-sm justify-content-center">
    <hr>
    <div>
        Sembra che la pagina che stai cercano non esista... ritorna alla <a href="home"> Home Page</a>.
    </div>
</div>